import { Popover } from '@sgme/ui';
import { IconButton } from 'components/shared/IconButton';
import { FormattedMessage } from 'components/shared/Intl';
import { useSPIntl } from 'hooks/useIntl';
import { useToggle } from 'hooks/useToggle';
import { FC } from 'react';
import styled from 'styled-components';

import { ResetFormPanel } from './ResetFormPanel';

const Backdrop = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 1;
  z-index: 1000;
`;

const StyledPopoverBody = styled.div`
  max-width: 30rem;
`;

type ResetProps = {
  isDisabled?: boolean;
  className?: string;
  iconName?: string;
  onResetTabClicked: () => void;
  onRefreshDefaultDatesClicked: () => void;
  onRefreshScheduleClicked: () => void;
};

export const ResetFormButton: FC<ResetProps> = ({
  isDisabled,
  className,
  iconName = 'replay',
  onResetTabClicked,
  onRefreshDefaultDatesClicked,
  onRefreshScheduleClicked,
}) => {
  const { isOn, toggle, toggleOff } = useToggle(false);
  const { formatMessage } = useSPIntl();

  return (
    <>
      <Popover
        open={isOn}
        maxWidth={320}
        style={{ padding: 0 }}
        contents={
          <StyledPopoverBody className="bg-lvl1 text-primary p-4 text-start shadow" data-e2e="reset-dropdown-popup">
            <ResetFormPanel
              onClose={toggleOff}
              onResetTabClicked={onResetTabClicked}
              onRefreshDefaultDatesClicked={onRefreshDefaultDatesClicked}
              onRefreshScheduleClicked={onRefreshScheduleClicked}
            />
            <button
              className="mt-4 btn btn-discreet-secondary btn-xl w-100"
              onClick={toggleOff}
              aria-label={formatMessage({ id: 'reset.tab.btn.ariaLabel' })}
            >
              <FormattedMessage id="cancel" defaultMessage="Cancel" />
            </button>
          </StyledPopoverBody>
        }
      >
        <IconButton
          onClick={toggle}
          iconName={iconName}
          isDisabled={isDisabled}
          className={className}
          e2e="reset-btn"
        />
      </Popover>
      {isOn && <Backdrop onClick={toggleOff} />}
    </>
  );
};
